import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ServiceNowSvg = function ServiceNowSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#293D40",
    d: "M19.5 2h-15A2.5 2.5 0 0 0 2 4.5v15A2.5 2.5 0 0 0 4.5 22h15a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 19.5 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 13.994V10.08h1.043v.316c.32-.258.724-.396 1.14-.396.54 0 1.054.228 1.4.63.264.306.417.701.417 1.373v1.994H7.917v-2.074c0-.383-.094-.589-.244-.733a.88.88 0 0 0-.61-.219c-.386.013-.746.19-.983.486V14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81B4A0",
    d: "M12.013 10C10.9 10.003 10 11.012 10 12.255c0 .611.226 1.195.622 1.617a.37.37 0 0 0 .518.032 1.32 1.32 0 0 1 1.716 0 .364.364 0 0 0 .523-.031c.803-.858.831-2.284.062-3.18A1.93 1.93 0 0 0 12.013 10m-.011 3.365c-.54.019-.99-.451-1.007-1.053v-.064c-.02-.618.416-1.135.97-1.154s1.018.464 1.035 1.082v.076c.014.602-.41 1.1-.95 1.116h-.051"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.21 14h-.737L14 10h.988l.808 2.288.79-2.288h.829l.783 2.288.814-2.288H20l-1.47 4h-.737L17 11.722z"
  }));
};
export var ServiceNow = function ServiceNow(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ServiceNowSvg
  }));
};